import isEmpty from 'lodash/isEmpty'
import { useEffect } from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { persistUTMParams } from '../../../store/session'

const UTMParams = ({ persistUTMParams, router: { location } }) => {
  useEffect(() => {
    const utmParams = Object.keys(location.query).reduce((utmParams, key) => {
      if (key.indexOf('utm') === 0) {
        return { ...utmParams, [key]: location.query[key] }
      } else {
        return utmParams
      }
    }, {})

    if (!isEmpty(utmParams)) persistUTMParams(utmParams)
  }, [location.query])

  return null
}

export default compose(
  connect(null, { persistUTMParams }),
  withRouter
)(UTMParams)
